@if ((formSubmitted()) === false) {
<brand-form
    [formSubmit]="onFormSubmit"
    (formStatusChange)="onFormStatusChange($event)"
    [fields]="fields"
    class="text-bg-light custom-form"
    id="requestQuoteForm"
>
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-4">
                <h3
                    [innerHTML]="
                        'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_TITLE_TEXT'
                            | translate
                    "
                    class="mb-2"
                ></h3>
                <p
                    [innerHTML]="
                        'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_DESCRIPTION_TEXT'
                            | translate
                    "
                ></p>
            </div>
            <div class="col-12 col-lg-8">
                <div class="row">
                    <div class="col-12 col-lg-6 mb-1">
                        <brand-form-input
                            [customError]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_WARNING_FIRST-NAME_TEXT'
                                    | translate
                            "
                            [label]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_FIRST-NAME_TEXT'
                                    | translate
                            "
                            [placeholder]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_FIRST-NAME_TEXT'
                                    | translate
                            "
                            [class]="'custom-input'"
                            name="firstName"
                            [errorIconImageUrl]="errorIconUrl"
                        >
                        </brand-form-input>
                    </div>
                    <div class="col-12 col-lg-6 mb-1">
                        <brand-form-input
                            [customError]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_WARNING_LAST-NAME_TEXT'
                                    | translate
                            "
                            [label]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_LAST-NAME_TEXT'
                                    | translate
                            "
                            [placeholder]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_LAST-NAME_TEXT'
                                    | translate
                            "
                            [class]="'custom-input'"
                            name="lastName"
                            [errorIconImageUrl]="errorIconUrl"
                        >
                        </brand-form-input>
                    </div>
                    <div class="col-12 col-lg-6 mb-1">
                        <brand-form-input
                            [customError]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_WARNING_EMAIL_TEXT'
                                    | translate
                            "
                            [label]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_EMAIL_TEXT'
                                    | translate
                            "
                            [placeholder]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_EMAIL_TEXT'
                                    | translate
                            "
                            [class]="'custom-input'"
                            name="email"
                            [errorIconImageUrl]="errorIconUrl"
                        >
                        </brand-form-input>
                    </div>
                    <div class="col-12 col-lg-6 mb-1">
                        <brand-form-input
                            [customError]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_WARNING_PHONE_TEXT'
                                    | translate
                            "
                            [label]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_PHONE_TEXT'
                                    | translate
                            "
                            [placeholder]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_PHONE_TEXT'
                                    | translate
                            "
                            [class]="'custom-input'"
                            name="phone"
                            [errorIconImageUrl]="errorIconUrl"
                        >
                        </brand-form-input>
                    </div>
                    <div class="col-12 col-lg-6 mb-1">
                        <vision2-country-selector
                            (selectedCountryChange)="onCountryChange($event)"
                            name="country"
                            [customError]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_WARNING_REGION_TEXT'
                                    | translate
                            "
                            [label]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_REGION_TEXT'
                                    | translate
                            "
                            [errorIconImageUrl]="errorIconUrl"
                        ></vision2-country-selector>
                    </div>
                    <div class="col-12 col-lg-6 mb-1 pb-3">
                        <brand-form-input
                            [customError]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_WARNING_POSTAL-CODE_TEXT'
                                    | translate
                            "
                            [label]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_POSTAL-CODE_TEXT'
                                    | translate
                            "
                            [placeholder]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_POSTAL-CODE_TEXT'
                                    | translate
                            "
                            [class]="'custom-input'"
                            name="postalCode"
                            [errorIconImageUrl]="errorIconUrl"
                        >
                        </brand-form-input>
                    </div>
                    <div class="col-12 mb-1 pb-3">
                        <brand-form-radio
                            [customError]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_WARNING_LOCATION-QUESTION_TEXT'
                                    | translate
                            "
                            [label]="
                                'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_LOCATION-QUESTION_TEXT'
                                    | translate
                            "
                            [options]="[
                                {
                                    value:
                                        'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_LOCATION-QUESTION_COMMERCIAL_TEXT'
                                        | translate,
                                    id: 'location_commercial'
                                },
                                {
                                    value:
                                        'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_LOCATION-QUESTION_RETAIL_TEXT'
                                        | translate,
                                    id: 'location_retail'
                                }
                            ]"
                            name="location"
                        >
                        </brand-form-radio>
                    </div>
                    <div class="col-12">
                        <brand-form-submit-button
                            [label]="
                                'CONTACT-US_SUBMIT-BUTTON_TEXT' | translate
                            "
                            [dataCyButton]="'contactUsFormSubmitButton'"
                            [spinnerClass]="
                                'spinner-border spinner-border-sm mr-2'
                            "
                            [class]="'btn-primary'"
                        >
                        </brand-form-submit-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</brand-form>
} @else {
<div class="text-center">
    <h1
        [innerHtml]="
            'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_SUCCESS_TITLE_TEXT'
                | translate
        "
        class="text-blue-300"
    ></h1>
    <div
        [innerHtml]="
            'PRODUCT-PAGE_GLOBAL_REQUEST-QUOTE-FORM_SUCCESS_DESCRIPTION_TEXT'
                | translate
        "
    ></div>
</div>
}
